import { render } from "./VehicleDetectionDashboard.vue?vue&type=template&id=0e810c48&scoped=true"
import script from "./VehicleDetectionDashboard.vue?vue&type=script&lang=js"
export * from "./VehicleDetectionDashboard.vue?vue&type=script&lang=js"

import "./VehicleDetectionDashboard.vue?vue&type=style&index=0&id=0e810c48&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e810c48"]])

export default __exports__